var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleIcon16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#GoogleIcon16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M15.674 8.175q-.001-.85-.145-1.635H7.997v3.093h4.304a3.68 3.68 0 0 1-1.596 2.414v2.006h2.584c1.513-1.392 2.385-3.442 2.385-5.878"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M7.997 15.994c2.16 0 3.97-.716 5.293-1.937l-2.584-2.007c-.717.48-1.633.764-2.709.764-2.082 0-3.845-1.407-4.474-3.297H.85v2.072a7.99 7.99 0 0 0 7.146 4.405"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M3.522 9.516a4.8 4.8 0 0 1-.25-1.52c0-.526.09-1.039.25-1.519V4.405H.85a8.001 8.001 0 0 0 0 7.183z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M7.997 3.181c1.174 0 2.229.403 3.057 1.195l2.294-2.292C11.963.792 10.153 0 7.998 0A7.99 7.99 0 0 0 .85 4.406l2.672 1.183c.629-1.89 2.392-2.408 4.474-2.408"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "GoogleIcon16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15.994v15.994H0z"
})))));
export default SvgGoogleIcon16;